import React, { Component } from 'react';
import { connect } from 'react-redux';
import CKEditorComponent from '@/components/Editor/CKEditorComponent';


class Editor extends Component {

    handleEditorChange = (data) => {
        //console.log(data)
        this.setState({ editorData: data });
    };

    render() {

        return (
            <div className='mt-4'>
                <CKEditorComponent
                    onChange={this.handleEditorChange}
                    initialHeight="600px"
                />
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Editor);
